import React from 'react';
import TagsSettings from '../features/settings/tags/TagsSettings';

const TagsSettingsPage: React.FC = () => {
    return <TagsSettings />;
};

export default TagsSettingsPage;
